/* eslint-disable vue/no-unused-vars */
<template>
  <div class="card">
    <div class="card-header">
      <div class="utils__title">
        <strong>Productos</strong>
      </div>
    </div>
    <div class="card-body">
      <a-table
        class="utils__scrollTable"
        :scroll="{ x: '100%' }"
        :columns="columns"
        rowKey="id"
        :dataSource="tableData"
        :pagination="pagination"
        :loading="loading"
        @change="handleTableChange"
      >
        <!--
        <a
          slot="id"
          slot-scope="text"
          href="javascript: void(0);"
          class="utils__link--underlined"
          >#{{ text }}</a
        >
        <span slot="action">
          <a-button icon="edit" class="mr-1" size="small">View</a-button>
          <a-button icon="cross" size="small">Remove</a-button>
        </span>
        -->

        <template slot="title" slot-scope="">
          <a-button class="editable-add-btn" @click="handleAdd"
            >+ Nuevo</a-button
          >
        </template>
        <template
          v-for="col in [
            'id',
            'name',
            'ERPCode',
            'harmonyCode',
            'isSubscription'
          ]"
          :slot="col"
          slot-scope="text, record"
        >
          <div :key="col">
            <span v-if="record.editable">
              <a-select
                v-if="col == 'isSubscription'"
                :defaultValue="
                  record.isSubscription == undefined
                    ? ''
                    : record.isSubscription
                "
                @change="val => handleChange(val, record.id, col)"
              >
                <a-select-option key="" value=""> Seleccionar </a-select-option>
                <a-select-option :key="true" :value="true">Si </a-select-option>
                <a-select-option :key="false" :value="false"
                  >No
                </a-select-option>
              </a-select>
              <a-input
                v-else
                style="margin: -5px 0"
                :value="text"
                @change="e => handleChange(e.target.value, record.id, col)"
              />
            </span>
            <span v-else>
              <template v-if="col == 'isSubscription'">
                <span v-if="text == true">Si</span>
                <span v-else>No</span>
              </template>
              <template v-else>{{ text }}</template>
            </span>
          </div>
        </template>

        <span slot="operation" slot-scope="text, record">
          <span v-if="record.add">
            <a-button
              icon="plus"
              class="mr-1"
              size="small"
              @click="() => addRecord(record.id)"
              >Agregar
            </a-button>
            <a-popconfirm
              title="¿Seguro desea cancelar?"
              okText="Si"
              cancelText="No"
              @confirm="() => fetchTableData()"
            >
              <a-button icon="cross" class="mr-1" size="small"
                >Cancelar
              </a-button>
            </a-popconfirm>
          </span>
          <span v-else>
            <span v-if="record.editable">
              <a-button
                icon="edit"
                class="mr-1"
                size="small"
                @click="() => saveRecord(record.id)"
                >Guardar
              </a-button>
              <a-popconfirm
                title="¿Seguro desea cancelar?"
                okText="Si"
                cancelText="No"
                @confirm="() => cancelEdit(record.id)"
              >
                <a-button icon="cross" class="mr-1" size="small"
                  >Cancelar
                </a-button>
              </a-popconfirm>
            </span>
            <span v-else>
              <a-button
                icon="edit"
                class="mr-1"
                size="small"
                @click="() => editRow(record.id)"
                >Editar</a-button
              >
              <a-popconfirm
                v-if="tableData.length"
                title="¿Seguro desea eliminar el registro?"
                @confirm="() => deleteRecord(record.id)"
              >
                <a-button icon="cross" class="mr-1" size="small"
                  >Borrar</a-button
                >
              </a-popconfirm>
            </span>
          </span>
        </span>
      </a-table>
    </div>
  </div>
</template>

<script>
//import { data } from "./data.json";
import { mapActions } from "vuex";
import store from "@/store";
const columns = [
  {
    title: "Id",
    dataIndex: "id",
    key: "id",
    sorter: true
  },
  {
    title: "Nombre",
    dataIndex: "name",
    key: "name",
    sorter: true,
    scopedSlots: { customRender: "name" }
  },
  {
    title: "Código ERP",
    dataIndex: "ERPCode",
    key: "ERPCode",
    sorter: true,
    scopedSlots: { customRender: "ERPCode" }
  },
  {
    title: "Código Harmony",
    dataIndex: "harmonyCode",
    key: "harmonyCode",
    sorter: true,
    scopedSlots: { customRender: "harmonyCode" }
  },
  {
    title: "Subscripción",
    dataIndex: "isSubscription",
    key: "isSubscription",
    sorter: true,
    scopedSlots: { customRender: "isSubscription" }
  },
  {
    title: "Acciones",
    key: "operation",
    scopedSlots: { customRender: "operation" }
  }
];
const tableData = [];
export default {
  data() {
    this.cacheData = tableData.map(item => ({ ...item }));
    return {
      tableData: [],
      cachedData: {},
      pagination: {
        position: "bottom"
      },
      loading: false,
      columns
    };
  },
  methods: {
    ...mapActions({
      loadProducts: "products/load",
      saveProduct: "products/save",
      addProduct: "products/add",
      deleteProduct: "products/delete"
    }),
    handleAdd() {
      //chekea si ya hay una fila para agregar nuevo registro
      if (!this.tableData.filter(item => "+" === item.id)[0]) {
        const { count, tableData } = this;
        const newData = {
          id: "+",
          name: "",
          ERPCode: null
        };
        this.tableData = [newData, ...tableData];
        //this.count = count + 1;
        const target = this.tableData.filter(item => "+" === item.id)[0];
        if (target) {
          target.editable = true;
          target.add = true;
          //this.tableData = newData;
          //this.cachedRow = Object.assign({}, target);
        }
      }
    },
    handleTableChange(pagination, filters, sorter) {
      //console.log(pagination);

      const pager = { ...this.pagination };
      pager.current = pagination.current;
      this.pagination = pager;
      let orderAsc = true;
      //console.log(sorter);
      if (sorter.order == "descend") orderAsc = false;
      this.fetchTableData({
        pageSize: pagination.pageSize,
        page: pagination.current,
        orderBy: sorter.field,
        orderAsc: orderAsc
      });
    },
    async fetchTableData(params = {}) {
      try {
        //console.log("params:", params);
        this.loading = true;
        const result = await this.loadProducts(params);
        const pagination = {
          ...store.state.products.pagination
        };
        // Read total count from server
        pagination.total = pagination.totalResults;
        this.loading = false;
        const newData = store.state.products.results;
        this.tableData = newData;
        this.pagination = pagination;
      } catch (error) {
        this.loading = false;
        this.$notification["warning"]({
          message: error.code,
          description: error.message
        });
      }
    },
    handleChange(value, key, column) {
      //alert("change");
      //console.log({ value, key, column });
      const newData = [...this.tableData];
      const target = newData.filter(item => key === item.id)[0];
      if (target) {
        target[column] = value;
        this.tableData = newData;
      }
    },
    editRow(key) {
      const newData = [...this.tableData];
      const target = newData.filter(item => key === item.id)[0];
      if (target) {
        target.editable = true;
        this.tableData = newData;
        this.cachedRow = Object.assign({}, target);
      }
    },
    cancelEdit(key) {
      const newData = [...this.tableData];
      let target = newData.filter(item => key === item.id)[0];
      if (target) {
        Object.assign(target, this.cachedRow);
        delete target.editable;
        delete target.add;
        this.tableData = newData;
      }
    },
    async addRecord() {
      try {
        const newData = [...this.tableData];
        const target = newData.filter(item => "+" === item.id)[0];
        if (target) {
          console.log("params:", params);
          this.loading = true;
          const params = {
            name: target.name,
            ERPCode: target.ERPCode,
            harmonyCode: target.harmonyCode,
            isSubscription: target.isSubscription
          };
          const result = await this.addProduct(params);
          delete target.editable;
          delete target.add;
          const result2 = await this.fetchTableData();
        }
      } catch (error) {
        this.loading = false;
        this.$notification["warning"]({
          message: error.code,
          description: error.message
        });
      }
    },
    async saveRecord(key) {
      try {
        const newData = [...this.tableData];
        const target = newData.filter(item => key === item.id)[0];
        if (target) {
          //console.log("params:", params);
          this.loading = true;
          const params = {
            id: target.id,
            name: target.name,
            ERPCode: target.ERPCode,
            harmonyCode: target.harmonyCode,
            isSubscription: target.isSubscription
          };
          const result = await this.saveProduct(params);
          this.tableData = newData;
          delete target.editable;
          this.loading = false;
        }
      } catch (error) {
        this.loading = false;
        this.$notification["warning"]({
          message: error.code,
          description: error.message
        });
      }
    },
    async deleteRecord(key) {
      try {
        const newData = [...this.tableData];
        const target = newData.filter(item => key === item.id)[0];
        if (target) {
          this.loading = true;
          const result = await this.deleteProduct(key);
          this.tableData = newData.filter(item => item.id !== key);
          this.loading = false;
        }
      } catch (error) {
        //this.$nprogress.done();
        this.loading = false;
        this.$notification["warning"]({
          message: error.code,
          description: error.message
        });
      }
    }
  },
  computed: {},
  mounted() {
    this.fetchTableData();
  }
};
</script>

<style lang="css">
.card-body {
  padding-top: 0;
}
</style>

<style lang="scss" module scoped>
@import "./style.module.scss";
.editable-row-operations a {
  margin-right: 8px;
}
</style>
